module.exports = __webpack_public_path__ + "static/media/garage.07607f32.png";